import { apiService } from '../../..'
import {
  BankingSessionRequest,
  BankingSessionResponse,
  LatestBankingSessionResponse,
  UpdateBankingSessionRequest,
  UpdateBankingSessionsResponse,
} from '../types'

export const bankingService = apiService.service.injectEndpoints({
  endpoints: (build) => ({
    createBankingSession: build.mutation<BankingSessionResponse, BankingSessionRequest>({
      query: ({ onCompleteUrl, onCancelUrl }) => {
        return {
          url: `/portal/consumers/banking-sessions`,
          method: 'POST',
          data: { onCancelUrl, onCompleteUrl },
        }
      },
      invalidatesTags: ['BankingSessions'],
    }),
    // Deprecated endpoint - To be removed FLE-2760
    getLatestBankingSession: build.query<LatestBankingSessionResponse, void>({
      query: () => {
        return {
          url: `/portal/consumers/latest-banking-session`,
          method: 'GET',
        }
      },
      providesTags: ['BankingSessions'],
    }),
    getBankingSessionLatest: build.query<LatestBankingSessionResponse, void>({
      query: () => {
        return {
          url: `/portal/consumers/banking-sessions/latest`,
          method: 'GET',
        }
      },
      providesTags: ['BankingSessions'],
    }),

    updateBankingSessions: build.mutation<UpdateBankingSessionsResponse, UpdateBankingSessionRequest>({
      query: ({ onCompleteUrl, onCancelUrl }) => {
        return {
          url: `/portal/consumers/banking-sessions`,
          method: 'PUT',
          data: { onCompleteUrl, onCancelUrl },
        }
      },
      invalidatesTags: ['BankingSessions'],
    }),
  }),
})
